/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Today_Day_Done_DetailInputs */

const en_us2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done · ${i?.time}`)
};

const pt_br2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Concluído · ${i?.time}`)
};

const es_419_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completado · ${i?.time}`)
};

const pt_pt2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Concluído · ${i?.time}`)
};

const fr_fr2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terminée · ${i?.time}`)
};

const de_de2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erledigt · ${i?.time}`)
};

const it_it2_today_day_done_detail = /** @type {(inputs: Today_Day_Done_DetailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Completato · ${i?.time}`)
};

/**
* | output |
* | --- |
* | "Done · {time}" |
*
* @param {Today_Day_Done_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_done_detail = /** @type {((inputs: Today_Day_Done_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_Done_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_done_detail(inputs)
	if (locale === "es-419") return es_419_today_day_done_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_done_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_done_detail(inputs)
	if (locale === "de-DE") return de_de2_today_day_done_detail(inputs)
	if (locale === "it-IT") return it_it2_today_day_done_detail(inputs)
	return en_us2_today_day_done_detail(inputs)
});
export { today_day_done_detail as "today.day_done_detail" }